import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
var _excluded = ["onValidValueChange", "patternInvalidMessage", "required"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
import './TextInputWithValidation.css';
import React, { useState } from 'react';
export var TextInputWithValidation = function TextInputWithValidation(_ref) {
  var onValidValueChange = _ref.onValidValueChange,
    patternInvalidMessage = _ref.patternInvalidMessage,
    required = _ref.required,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isInvalidMarked = _useState2[0],
    setIsInvalidMarked = _useState2[1];
  var _onBlur = function onBlur(e) {
    if (e.currentTarget.validity.valid) {
      onValidValueChange && onValidValueChange(e.currentTarget.value);
      setIsInvalidMarked(false);
    } else {
      onValidValueChange && onValidValueChange("");
      setIsInvalidMarked(true);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: commonStyles
  }, /*#__PURE__*/React.createElement("input", _extends({
    className: isInvalidMarked ? "text-input__invalid" : undefined
  }, props, {
    onBlur: function onBlur(e) {
      props.onBlur && props.onBlur(e);
      _onBlur(e);
    },
    onFocus: function onFocus() {
      return setIsInvalidMarked(false);
    }
  })), isInvalidMarked && patternInvalidMessage && /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("p", {
    className: "text-input__error"
  }, patternInvalidMessage)));
};
var commonStyles = "cnfdixi";